import React from 'react';

function CameraAppointmentConfirmedIcon() {
    return <svg
        className="camera-icon"
        width="22px"
        height="18px"
        viewBox="0 0 14 10"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink">
        <title>4B6D1136-DA48-4507-92FA-85A8C2D529DF@1,5x</title>
        <g
            id="08---Consultas-Online"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd">
            <g
                id="MY-D-08-01-17"
                transform="translate(-987.000000, -493.000000)"
                fill="#00B1D1"
                fillRule="nonzero">
                <g
                    id="Group-2"
                    transform="translate(382.000000, 462.000000)">
                    <g
                        id="cards/lista_médicos-copy-5"
                        transform="translate(0.000000, 27.000000)">
                        <g
                            id="Group"
                            transform="translate(605.000000, 2.000000)">
                            <g
                                id="ELEMENTS/ICONS/Camera/Standard"
                                transform="translate(0.656250, 2.406250)">
                                <path
                                    d="M11.7560953,0.624378667 L9.21563672,2.35527013 L9.21563672,1.79677314 C9.21563672,0.804442737 8.53692838,0 7.69969922,0 L1.5159375,0 C0.678708337,0 0,0.804442737 0,1.79677314 L0,7.39072686 C0,8.38305726 0.678708337,9.1875 1.5159375,9.1875 L7.69969922,9.1875 C8.53692838,9.1875 9.21563672,8.38305726 9.21563672,7.39072686 L9.21563672,6.83222987 L11.7560953,8.56312133 C12.2374055,8.89103243 12.6328125,8.62151646 12.6328125,7.96419695 L12.6328125,1.22629767 C12.6328125,0.56598354 12.2386688,0.296467568 11.7560953,0.624378667 Z"
                                    id="lists/icon_camera-small"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
}
export default CameraAppointmentConfirmedIcon;